<div class="small-spinner-container" *ngIf="loading">
  <mat-spinner [diameter]="40"></mat-spinner>
  <span class="loading-message">{{message}}</span>
</div>
<div *ngIf="!loading">
  <ng-content select="[field]"></ng-content>
</div>
